<template>
    <section
        ref="section18"
        :class="[
            Object.keys(validationErrors).length > 0 ? 'has-errors' : '',
            'mx-auto flex h-full flex-col',
        ]"
    >
        <v-add-listing-head :routes="routes" :step="21"></v-add-listing-head>
        <main
            class="flex h-full flex-col items-center justify-between overflow-y-scroll px-4 py-8 md:px-12"
        >
            <figure class="flex max-w-lg flex-col gap-11 lg:w-full">
                <figure class="flex gap-3">
                    <div><v-icon icon="car" size="8"></v-icon></div>
                    <div class="flex flex-col justify-center">
                        <div class="mb-3 text-heading-3-desktop">
                            Parkirna mesta
                        </div>
                        <div class="text-body-regular text-black-40">
                            Označite katere vrste parkirnih mest ima
                            nepremičnina in vnesite število parkirnih mest.
                            Lahko izberete več možnosti.
                        </div>
                    </div>
                </figure>
                <form
                    method="POST"
                    :action="routes.submitForm"
                    id="select-parking-spaces"
                >
                    <v-csrf-token></v-csrf-token>
                    <ul class="grid grid-cols-4 flex-col gap-x-5 gap-y-4">
                        <li
                            class="col-span-4"
                            v-for="(
                                garage, onOfficeEnum
                            ) in stepData.stellplatzart_options"
                            :key="'garage-' + onOfficeEnum"
                        >
                            <v-checkbox
                                :id="onOfficeEnum"
                                class="text-small-text-medium text-black-78"
                                :label="
                                    stepData.labels.stellplatzart.values[
                                        onOfficeEnum
                                    ]
                                "
                                checkbox-position="right"
                                :name="'stellplatzart[' + onOfficeEnum + ']'"
                                :value="onOfficeEnum"
                                :icon="garage.icon"
                                :checked="
                                    stepData.stellplatzart != null &&
                                    stepData.stellplatzart[onOfficeEnum]
                                "
                            ></v-checkbox>
                        </li>
                    </ul>
                </form>
            </figure>
        </main>
        <v-add-listing-foot>
            <a
                @click="submitForm('select-parking-spaces')"
                class="button button--md h-[48px] w-[240px] px-6"
            >
                <label class="text-small-text-medium">Nadaljujte</label>
                <v-icon icon="arrow-right" size="4"></v-icon>
            </a>
        </v-add-listing-foot>
    </section>
</template>
<script>
import AddListingFootVue from "../AddListingFoot.vue";
import AddListingHeadVue from "../AddListingHead.vue";

export default {
    components: {
        "v-add-listing-foot": AddListingFootVue,
        "v-add-listing-head": AddListingHeadVue,
    },

    props: {
        old: {
            type: Object,
            required: false,
            default: {},
        },
        routes: {
            type: Object,
            required: true,
        },
        validationErrors: {
            type: Object,
            required: true,
            default: {},
        },
        stepData: {
            type: Object,
            required: true,
            default: {},
        },
    },

    data() {
        return {
            isMonument: null,
            allowsAnimals: null,
        };
    },
    mounted() {
        this.isMonument = this.stepData.denkmalgeschuetzt;
        this.allowsAnimals = this.stepData.haustiere;
    },
    computed: {},
    methods: {
        submitForm(formId) {
            document.getElementById(formId).submit();
        },
    },
};
</script>
